// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.geofence-modal {
  height: 100%;
}
.geofence-modal .leaflet-container {
  min-height: 360px;
  height: 100%;
}
.geofence-modal .leaflet-top {
  color: #333;
}

.driver-page-content .maparea2 {
  height: 100%;
}

.with-timeline .leaflet-container {
  min-height: calc(100vh - 81px - 50px);
  height: auto !important;
}
.with-timeline.rows-shown-10 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 10);
}
.with-timeline.rows-shown-9 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 9);
}
.with-timeline.rows-shown-8 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 8);
}
.with-timeline.rows-shown-7 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 7);
}
.with-timeline.rows-shown-6 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 6);
}
.with-timeline.rows-shown-5 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 5);
}
.with-timeline.rows-shown-4 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 4);
}
.with-timeline.rows-shown-3 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 3);
}
.with-timeline.rows-shown-2 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 2);
}
.with-timeline.rows-shown-1 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 1);
}
.with-timeline.rows-shown-0 .leaflet-container {
  min-height: calc(100vh - 50px - 30px * 0);
}
.with-timeline .leaflet-popup-content {
  min-width: 180px;
}
.with-timeline .vis-labelset {
  min-width: 150px;
}
.with-timeline .vis-custom-time {
  z-index: 999;
}
.with-timeline .vis-custom-time {
  width: 4px;
}
.with-timeline .speed-slider {
  background: #fff;
  width: 110px;
  position: absolute;
  bottom: 10px;
  left: 10px;
  padding: 5px 10px;
  color: #4d4d4d;
  z-index: 9999;
  border: 2px solid rgba(0, 0, 0, 0.25);
  background-clip: padding-box;
  border-radius: 4px;
}
.with-timeline .speed-slider label {
  font-size: 12px;
}
.with-timeline .speed-slider .slider {
  max-height: 20px;
  top: -15px;
}

.checkbox {
  cursor: pointer;
}

@media (max-width: 1499px) {
  .custom-map-notification {
    min-height: 100%;
  }
}
.custom-map-notification {
  min-height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Monitoring/Style.scss"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;AACE;EACE,iBAAA;EACA,YAAA;AACJ;AACE;EACE,WAAA;AACJ;;AAGE;EACE,YAAA;AAAJ;;AAKE;EACE,qCAAA;EACA,uBAAA;AAFJ;AAOM;EACE,0CAAA;AALR;AAIM;EACE,yCAAA;AAFR;AACM;EACE,yCAAA;AACR;AAFM;EACE,yCAAA;AAIR;AALM;EACE,yCAAA;AAOR;AARM;EACE,yCAAA;AAUR;AAXM;EACE,yCAAA;AAaR;AAdM;EACE,yCAAA;AAgBR;AAjBM;EACE,yCAAA;AAmBR;AApBM;EACE,yCAAA;AAsBR;AAvBM;EACE,yCAAA;AAyBR;AAjBE;EACE,gBAAA;AAmBJ;AAhBE;EACE,gBAAA;AAkBJ;AAfE;EACE,YAAA;AAiBJ;AAfE;EACE,UAAA;AAiBJ;AAbE;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,qCAAA;EACA,4BAAA;EACA,kBAAA;AAeJ;AAdI;EACE,eAAA;AAgBN;AAdI;EACE,gBAAA;EACA,UAAA;AAgBN;;AAXA;EACE,eAAA;AAcF;;AAVA;EACE;IACE,gBAAA;EAaF;AACF;AAXA;EACE,gBAAA;AAaF","sourcesContent":["@import '../../assets/variables';\n.geofence-modal {\n  height: 100%;\n  .leaflet-container {\n    min-height: 360px;\n    height: 100%;\n  }\n  .leaflet-top {\n    color: #333;\n  }\n}\n.driver-page-content {\n  .maparea2 {\n    height: 100%;\n  }\n}\n\n.with-timeline {\n  .leaflet-container {\n    min-height: calc(100vh - 81px - #{$headerHeight});\n    height: auto !important;\n  }\n\n  @for $i from 10 through 0 {\n    &.rows-shown-#{$i} {\n      .leaflet-container {\n        min-height: calc(\n          100vh - #{$headerHeight} - \n            (30px * #{$i})\n        );\n      }\n    }\n  }\n\n  .leaflet-popup-content {\n    min-width: 180px;\n  }\n\n  .vis-labelset {\n    min-width: 150px;\n  }\n\n  .vis-custom-time {\n    z-index: 999;\n  }\n  .vis-custom-time {\n    width: 4px;\n    //background: #999;\n  }\n\n  .speed-slider {\n    background: #fff;\n    width: 110px;\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    padding: 5px 10px;\n    color: #4d4d4d;\n    z-index: 9999;\n    border: 2px solid rgba(0, 0, 0, 0.25);\n    background-clip: padding-box;\n    border-radius: 4px;\n    label {\n      font-size: 12px;\n    }\n    .slider {\n      max-height: 20px;\n      top: -15px;\n    }\n  }\n}\n\n.checkbox {\n  cursor: pointer;\n}\n\n// responsive\n@media (max-width: 1499px) {\n  .custom-map-notification {\n    min-height: 100%;\n  }\n}\n.custom-map-notification {\n  min-height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
